import { Outlet, createFileRoute } from "@tanstack/react-router";
import queryClient from "api/queryClient.ts";
import { getOutgoingPostbackQueryOptions } from "api/TenantSlug/OutgoingPostback/queryOptions.ts";
import { QueryState } from "components/UI/QueryState/QueryState.tsx";

export const Route = createFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout"
)({
    loader: async ({ params: { id } }) => {
        let breadcrumb = id;

        try {
            const { outgoingPostback } = await queryClient.ensureQueryData(getOutgoingPostbackQueryOptions(id));

            breadcrumb = outgoingPostback.name;
        } catch (e) {
            console.error(e);
        }

        return {
            breadcrumb,
        };
    },
    pendingComponent: () => <QueryState isLoading={true} isError={false} />,
    errorComponent: () => <QueryState isLoading={false} isError={true} errorKey="errors.loading_outgoing_postback" />,
    component: () => <Outlet />,
});
